import { $$ } from './dom.js';

export function initAccordion() {
  const panels = $$('.service-panel');
  if (!panels.length) return;

  function open(panel) {
    panels.forEach((item) => {
      const active = item === panel;
      item.classList.toggle('is-open', active);
      item.querySelector('.service-trigger')?.setAttribute('aria-expanded', String(active));
      const icon = item.querySelector('.service-trigger i');
      if (icon) icon.textContent = active ? '−' : '+';
    });
  }

  panels.forEach((panel) => {
    panel.querySelector('.service-trigger')?.addEventListener('click', () => open(panel));
    panel.addEventListener('mouseenter', () => {
      if (matchMedia('(hover: hover) and (min-width: 841px)').matches) open(panel);
    });
  });
}
